import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { formatarTamanho } from "../../../../../function/utilis/function";
import { calcularEstadoOS, BOTOES_INICIAIS } from "./estadoOS";
import {
  consultarOS,
  listarDocumentosOS,
  listarDocumentosContexto,
  consultarContextoCliente,
} from "./service";

const INFO_INICIAL = {
  id: "",
  tipo: "",
  tipoId: "",
  situacao: "",
  situacaoId: "",
  dataCadastro: "",
  dataCadastroCliente: "",
  dataMigracao: "",
  dataCriacao: "",
  dataAlteracao: "",
  dataSituacao: "",
  dataSolicitacao: "",
  usuarioAlteracao: "",
  usuarioCadastro: "",
  usuarioSituacao: "",
  clienteId: "",
  cnpj: "",
  razaoSocial: "",
  carteiraId: null,
  equipeId: null,
  nome: "",
  codigoPromocional: "",
  observacao: "",
  contatoId: "",
  cpf: "",
  nomeCliente: "",
  telefone: "",
  email: "",
  cnpjEmpresa: "",
  razaoSocialEmpresa: "",
  nomeFantasia: "",
  nire: "",
  ie: "",
  contribuicaoEstadual: "",
  inscricaoEstadual: "",
  situacaoIE: "",
  incricaoMunicipal: "",
  simplesNacional: "",
  formaAtuacao: "",
  faturamento: "",
  quantidadeFuncionarios: "",
  tipoEmpresa: "",
  tipoPessoa: "",
  regimeTributario: "",
  atividade: "",
  capitalSocial: "",
  logradouro: "",
  numero: "",
  complemento: "",
  bairro: "",
  cidade: "",
  estado: "",
  cep: "",
  inscricaoImobiliaria: "",
  procuracaoDigital: "",
  acessoContador: "",
  certificadoCedido: "",
  dataAbertura: "",
  dataEncerramento: "",
  tipoAcessoECAC: "",
  senhaAcessoECAC: "",
  dataPedidoSN: "",
  dataOpcaoSN: "",
  certificadoDataExpiracao: "",
  codigoAcessoSN: "",
  cpfAcessoSN: "",
  codigoReciboIRPF1: "",
  codigoReciboIRPF2: "",
  codigoAcessoGov: "",
  senhaAcessoGov: "",
  codigoAcessoECAC: "",
  codigoAcessoEW: "",
  senhaAcessoEW: "",
  dataVencimento: "",
  descricao: "",
  valorAvulso: "",
  valorMensal: "",
  valorAssinatura: "",
  valorAdicional: "",
  qtdRecorrencias: "",
  formaPagamentoId: "",
  observacaoNegociacao: "",
  situacaoServico: "",
  cpfSocio: "",
  nomeSocio: "",
  percentualSocietario: "",
  estadoCivil: "",
  dataNascimento: "",
  enderecoEmpresa: "",
  fgExecucaoSuspensa: false,
  enquadramento: "",
  faixaFaturamento: "",
  triagemCapitalSocial: "",
  triagemCep: "",
  triagemComplemento: "",
  triagemEnderecoNumero: "",
  triagemEstadoCivil: "",
  triagemImovelResidencia: "",
  triagemMetragemUtilizado: "",
  triagemNomeFantasia: "",
  triagemQtdSocios: "",
  triagemSedeEmpresa: "",
  triagemSegmentoAtuacao: "",
  triagemUtilizaImovelInteiro: "",
};

/** Monta o objeto "info" (usado pelas telas de exibição) a partir da resposta da API. */
function mapearInfo(responseData) {
  const qsa = responseData.empresa?.qsa;
  const qsaData = Array.isArray(qsa) && qsa.length > 0 ? qsa[0] : null;

  return {
    id: responseData.id,
    tipo: responseData.tipo?.nome,
    tipoId: responseData.tipo?.id,
    situacao: responseData.situacao?.nome,
    situacaoId: responseData.situacao?.id,
    dataCadastro: responseData.dataCadastro,
    dataCadastroCliente: responseData.cliente?.dataCadastro || null,
    dataAlteracao: responseData.dataAlteracao || null,
    dataSituacao: responseData.dataSituacao,
    dataSolicitacao: responseData.dataCadastro || null,
    dataCriacao: responseData.dataCriacao,
    clienteId: responseData.cliente?.id || null,
    conselho: responseData.conselho,
    usuarioAlteracao: responseData.usuarioAlteracao?.id,
    usuarioCadastro: responseData.cliente?.usuarioCadastro?.id || null,
    usuarioAtribuicao: responseData.usuarioAtribuicao?.id,
    usuarioSituacao: responseData.usuarioSituacao?.id,
    cnpj: responseData.cliente?.cnpj,
    razaoSocial: responseData.cliente?.nome,
    carteiraId: responseData.cliente?.carteira?.id || null,
    equipeId: responseData.cliente?.equipe?.id || null,
    codigoPromocional: responseData.codigoPromocional,
    nome: responseData.usuarioCadastro?.nome,
    observacao: responseData.observacao,
    contatoId: responseData.contato?.id,
    cpf: responseData.contato?.cpf,
    nomeCliente: responseData.contato?.nome,
    telefone: responseData.contato?.telefone,
    email: responseData.contato?.email,
    cnpjEmpresa: responseData.empresa?.cnpj,
    razaoSocialEmpresa: responseData.empresa?.nome,
    nomeFantasia: responseData.empresa?.nomeFantasia,
    nire: responseData.empresa?.nire,
    ie: responseData.empresa?.ie,
    contribuicaoEstadual: responseData.empresa?.contribuicaoIe,
    inscricaoEstadual: responseData.empresa?.ie,
    situacaoIE: responseData.empresa.situacaoIe,
    incricaoMunicipal: responseData.empresa?.im,
    simplesNacional: responseData.empresa?.simplesNacional,
    dataMigracao: responseData.empresa?.dataMigracao ? dayjs(responseData.empresa.dataMigracao) : null,
    formaAtuacao: responseData.empresa?.formaAtuacao,
    faturamento: responseData.empresa?.faturamento,
    quantidadeFuncionarios: responseData.empresa?.quantidadeFuncionarios,
    descricaoAtividades: responseData.empresa?.descricaoAtividades,
    capitalSocial: responseData.empresa?.capitalSocial,
    tipoEmpresa: responseData.empresa?.tipo?.id,
    regimeTributario: responseData.empresa?.regimeTributario?.id,
    logradouro: responseData.cliente?.endereco?.logradouro,
    numero: responseData.cliente?.endereco?.numero,
    complemento: responseData.cliente?.endereco?.complemento,
    bairro: responseData.cliente?.endereco?.bairro,
    cidade: responseData.cliente?.endereco?.cidade,
    estado: responseData.cliente?.endereco?.uf,
    cep: responseData.cliente?.endereco?.cep,
    inscricaoImobiliaria: responseData.empresa?.inscricaoImobiliaria,
    procuracaoDigital: responseData.empresa?.credenciaisAcesso?.procuracaoDigital,
    acessoContador: responseData.empresa?.credenciaisAcesso?.acessoContador,
    certificadoCedido: responseData.empresa?.credenciaisAcesso?.certificadoCedido,
    dataAbertura: responseData.cliente?.empresa?.dataAbertura || null,
    dataEncerramento: responseData.empresa?.dataEncerramento || null,
    tipoAcessoECAC: responseData.empresa?.credenciaisAcesso?.tipoAcessoECAC?.id || null,
    dataPedidoSN: responseData.cliente?.dataPedidoSN || null,
    dataOpcaoSN: responseData.cliente?.dataOpcaoSN || null,
    senhaAcessoECAC: responseData.empresa?.credenciaisAcesso?.senhaAcessoECAC,
    certificadoDataExpiracao: responseData.empresa?.credenciaisAcesso?.certificadoDataExpiracao,
    codigoAcessoSN: responseData.empresa?.credenciaisAcesso?.codigoAcessoSN,
    cpfAcessoSN: responseData.empresa?.credenciaisAcesso?.cpfAcessoSN,
    codigoReciboIRPF1: responseData.empresa?.credenciaisAcesso?.codigoReciboIRPF1,
    codigoReciboIRPF2: responseData.empresa?.credenciaisAcesso?.codigoReciboIRPF2,
    codigoAcessoGov: responseData.empresa?.credenciaisAcesso?.codigoAcessoGov,
    senhaAcessoGov: responseData.empresa?.credenciaisAcesso?.senhaAcessoGov,
    codigoAcessoECAC2: responseData.empresa?.credenciaisAcesso?.codigoAcessoGov,
    codigoAcessoEW: responseData.empresa?.credenciaisAcesso?.codigoAcessoEW,
    senhaAcessoEW: responseData.empresa?.credenciaisAcesso?.senhaAcessoEW,
    certificadoModalidade: responseData.empresa?.credenciaisAcesso?.certificadoModalidade,
    certificadoSenha: responseData.empresa?.credenciaisAcesso?.certificadoSenha,
    certificadoTipo: responseData.empresa?.credenciaisAcesso?.certificadoTipo,
    dataVencimento: responseData.dataVencimento,
    descricao: responseData.descricao,
    valorAvulso: responseData.valorAvulso,
    valorMensal: responseData.valorMensal,
    valorAssinatura: responseData.valorAssinatura,
    valorAdicional: responseData.valorAdicional,
    qtdRecorrencias: responseData.qtdRecorrencias,
    formaPagamentoId: responseData.formaPagamento?.id,
    observacaoNegociacao: responseData.observacaoNegociacao,
    situacaoServico: responseData.cliente?.servico?.situacao?.id || null,
    cpfSocio: qsaData?.cpf || "",
    nomeSocio: qsaData?.nome || "",
    dataNascimento: qsaData?.dataNascimento || "",
    estadoCivil: qsaData?.estadoCivil || "",
    percentualSocietario: qsaData?.percentualSocietario || "",
    enderecoEmpresa: qsaData?.enderecoEmpresa || "",
    fgExecucaoSuspensa: responseData.fgExecucaoSuspensa,
    enquadramento: responseData.empresa?.enquadramento?.id,
    faixaFaturamento: responseData.cliente?.faixaFaturamento || 0,
    triagemCep: responseData.triagem?.cep || "",
    triagemComplemento: responseData.triagem?.complemento || "",
    triagemEnderecoNumero: responseData.triagem?.enderecoNumero || "",
    triagemEstadoCivil: responseData.triagem?.estadoCivil || "",
    triagemNomeFantasia: responseData.triagem?.nomeFantasia || "",
    triagemSedeEmpresa: responseData.triagem?.sedeEmpresa || "",
    triagemCapitalSocial: responseData.triagem?.capitalSocial || "",
    triagemQtdSocios: responseData.triagem?.qtdSocios || "",
    triagemImovelResidencia: responseData.triagem?.imovelResidencia || "",
    triagemMetragemUtilizado: responseData.triagem?.metragemUtilizado || "",
    triagemUtilizaImovelInteiro: responseData.triagem?.utilizaImovelInteiro || "",
    triagemSegmentoAtuacao: responseData.triagem?.segmentoAtuacao || "",
  };
}

const ESTADO_VAZIO = {
  botoes: { ...BOTOES_INICIAIS },
  mostrarMensagem: false,
  alertInfo: "",
  avisoToast: null,
  isAlertNegociacaoInicialSituacaoDiasUteis: false,
  isAlertNegociacaoInicial: false,
  isAlertSolicitacaoServicoUltrapassou: false,
  isAlertProcessoFinalizado: false,
  isAlertCancelada: false,
  isAlertOrdemSuspensa: false,
  showQuadroSocioAdministrativo: true,
  showQuadroSocioAdministrativoRadio: true,
  showEmpresa: true,
  showAcessos: true,
  showFaturamento: true,
  situacaoInicialParaNegociacao: "",
};

export function useOrdemServico(numeroSolicitacao) {
  const [dados, setDados] = useState(null);
  const [info, setInfo] = useState(INFO_INICIAL);
  const [objDocs, setObjDocs] = useState([]);
  const [docsContexto, setDocsContexto] = useState([]);
  const [filesContexto, setFilesContexto] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDocsContext, setLoadingDocsContext] = useState(false);
  const [estado, setEstado] = useState(ESTADO_VAZIO);
  const [reportleads, setReportleads] = useState(false);

  // "agora" é calculado uma única vez (igual ao componente original), não a
  // cada consulta — mantém o comportamento de referência de SLA já existente.
  const agora = useMemo(() => dayjs(), []);

  useEffect(() => {
    const perfilUsuario = localStorage.getItem("perfis");
    if (!perfilUsuario) return;
    const perfis = JSON.parse(perfilUsuario);
    perfis.forEach((p) => {
      if (p.id === "GRP_PORTAL_VENDAS") setReportleads(true);
    });
  }, []);

  const fetchListDocumentoContexto = async () => {
    setLoadingDocsContext(true);
    try {
      const responseData = await listarDocumentosContexto();
      const arquivos = responseData?.arquivos;
      const files = responseData?.files;

      if (Array.isArray(arquivos) && arquivos.length > 0) {
        const arquivosFormatados = arquivos.map((arq) => ({
          nome: arq.nome,
          path: arq.atributos?.path,
          modificado: dayjs(arq.atributos?.["datetime-modified"]).format("DD/MM/YYYY HH:mm"),
          tamanho: formatarTamanho(Number(arq.atributos?.length)),
        }));
        setDocsContexto(arquivosFormatados);
        setFilesContexto(files);
      } else {
        setDocsContexto([]);
      }
    } catch (error) {
      setDocsContexto([]);
    } finally {
      setLoadingDocsContext(false);
    }
  };

  const featchContexto = async (idCliente) => {
    try {
      await consultarContextoCliente(idCliente);
    } catch (error) {
      // silencioso, igual ao comportamento original
    }
  };

  const fetchListDocumento = async (idOrdem) => {
    setLoading(true);
    try {
      const responseData = await listarDocumentosOS(idOrdem);
      if (responseData?.files && Array.isArray(responseData.files)) {
        setObjDocs(responseData.files);
      }
    } catch (error) {
      // mantém comportamento original: apenas loga, sem toast
    } finally {
      setLoading(false);
    }
  };

  const resetStates = () => {
    setDados(null);
    setDocsContexto([]);
    setFilesContexto([]);
    setEstado(ESTADO_VAZIO);
    setInfo(INFO_INICIAL);
    setObjDocs([]);
  };

  const fetchData = async () => {
    if (!numeroSolicitacao) return;

    setLoading(true);
    try {
      const responseData = await consultarOS(numeroSolicitacao);
      if (!responseData) throw new Error("Nenhum dado retornado da API");

      if (responseData.cliente) {
        await featchContexto(responseData.cliente.id);
        await fetchListDocumentoContexto();
      }

      setDados(responseData);
      await fetchListDocumento(responseData.id);
      setInfo(mapearInfo(responseData));

      const novoEstado = calcularEstadoOS(responseData, agora);
      setEstado(novoEstado);
      if (novoEstado.avisoToast) toast.info(novoEstado.avisoToast);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!numeroSolicitacao) return;
    resetStates();
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [numeroSolicitacao]);

  return {
    dados,
    info,
    setInfo,
    objDocs,
    setObjDocs,
    docsContexto,
    setDocsContexto,
    filesContexto,
    loading,
    setLoading,
    loadingDocsContext,
    estado,
    setEstado,
    reportleads,
    fetchData,
    fetchListDocumento,
    fetchListDocumentoContexto,
  };
}
